<template lang="pug">
div
  .bg-login(style="background-image: url(assets/img/login-bg.jpg)" data-id="login-cover-image")
    .page-container.modal-dialog-centered.mx-auto.my-0(style="max-width: 500px;padding: 0 8px;")
      .login.login-v2.w-100.mx-auto(data-pageload-addclass='animated fadeIn')
        .user-wrap
          i.fas.fa-user
        .login-header
          .brand.text-yellow.text-center.text-uppercase
            b {{ $t("title.security_page") }}
        .login-content
          b-form.margin-bottom-0(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
            //- .form-group.m-b-20
            //-   DebounceInput(
            //-     type="text"
            //-     v-model.trim.lazy="$v.security_tag.$model"
            //-     :placeholder='$t("ui.security_tag")'
            //-     :disabled="loading"
            //-     :dirty="$v.security_tag.$dirty"
            //-     :error="$v.security_tag.$error"
            //-     readonly
            //-   )
            //-   ValidateResult(:value="$v.security_tag" :name="$t('ui.security_tag')")
            .form-group.m-b-20
              DebounceInput(
                type="text"
                style="-webkit-text-security:disc;"
                ref="security_code"
                v-model.trim.lazy="$v.security_code.$model"
                :placeholder='$t("ui.security_code")'
                :disabled="loading"
                :dirty="$v.security_code.$dirty"
                :error="$v.security_code.$error"
                :maxLength="$v.security_code.$params.maxLength.max"
              )
              ValidateResult(:value="$v.security_code" :name="$t('ui.security_code')")
            .form-group.m-b-20
              b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
            .login-buttons
              SubmitButton.btn.btn-block.btn-lg(icon="fa fa-sign-in-alt" :text="$t('ui.submit')" variant="primary" :loading="loading" isModal=false)
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, sameAs } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data: function() {
    return {
      security_tag: this.$store.getters.securityTag,
      security_code: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/overview"
    };
  },
  computed: {},
  mounted () {
    this.$refs.security_code.$el.focus();
  },
  validations: {
    security_tag: {
      required
    },
    security_code: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    }
  },
  methods: {
    reset: function() {
      this.$v.$reset()
      this.submission.success = true
      this.submission.status = ""
    },
    submit: function() {
      this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let security_code = this.security_code
        this.loading = true
        this.$store
          .dispatch("user/securityValidate", { security_code })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            
            if (this.submission.success == true) {
              const otpValidated = response.data[0]['2fa_validated'];
              if (otpValidated == 1) {
                this.$router.push("/otp")
              } else {
                if (this.$store.getters.profileStatus == "RESET") {
                  this.$router.push("/resetPassword")
                } else {
                  this.$router.push(this.redirect)
                }
              }
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag);
          });
      }
    }
  }
};
</script>
